import { Type } from "@angular/core";
import { RepositoryGridviewComponent } from './repository-gridview.component';

export * from "./repository-gridview.component";

export const REPOSITORY_GRIDVIEW_DIRECTIVES: Type<any>[] = [
    RepositoryGridviewComponent
];
